import {
  ref, computed,
} from 'vue';
import { useUpc } from '@common-vue/media-card-large';
import { useEnvProps } from '@composables/useEnvProps';
import { useProduct } from '@modules/product';
import useMembersOfProduct from '@composables/useMembersOfProduct';
import { useProductType } from '@composables/useProductType';
import { useBrand } from '@composables/useBrand';
import { useKillswitches } from '@modules/featureControl';
import { PzoService } from '../services';
import { fireLinkTag } from '../../../features/analytics/tagManager';

export default function usePzo() {
  const pzoEligibleIds = ref([]);

  const { productId } = useProduct();
  const { memberProductIds } = useMembersOfProduct();
  const { isConsolidatedStandard } = useProductType();
  const { isProduction } = useEnvProps();
  const { isMcom } = useBrand();
  const { killswitches: { pzoBadgingEnabled } } = useKillswitches();
  const { upcData, selectedUpcId } = useUpc(String(productId));
  const selectedProductId = computed(() => upcData.value.upcs[selectedUpcId.value]?.relationships.selectedProduct || productId);
  const checkEligibility = (eligibleIds, selectedId) => eligibleIds.value.includes(String(selectedId.value));
  const showBadge = computed(() => checkEligibility(pzoEligibleIds, selectedProductId));
  const showPzo = PzoService.showPzo(isMcom, pzoBadgingEnabled);

  const checkPzo = async () => {
    const pzoService = new PzoService(isProduction, isConsolidatedStandard ? memberProductIds.value : productId);
    const { List } = await pzoService.getPzoEligible();
    if (Array.isArray(List) && List.length) {
      fireLinkTag({ badging_type: 'pzo' });
      pzoEligibleIds.value = List.map((product) => `${product.productId}`);
    }
  };

  return { showBadge, showPzo, checkPzo };
}
